import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';

const BaseStyledAutocomplete = styled(Autocomplete)(() => ({
  width: '100%',
  height: '56px',
})) as typeof Autocomplete;

export default BaseStyledAutocomplete;
